export const REGISTER_NEW_USER = 'REGISTER_NEW_USER';
export const LOGIN = 'LOGIN';
export const LOGIN_WITH_FACEBOOK = 'LOGIN_WITH_FACEBOOK';
export const IS_LOGGED_IN = 'IS_LOGGED_IN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const UNSET_REDIRECT_URL = 'UNSET_REDIRECT_URL';
export const SET_IS_REGISTERED = 'IS_REGISTERED';
export const SET_IS_REGISTERED_WITH_NEWSLETTER = 'IS_REGISTERED_WITH_NEWSLETTER';

export const FETCH_CLUB_INTEGRATION_PIXEL = 'FETCH_CLUB_INTEGRATION_PIXEL';
export const FETCH_CLUB_INTEGRATION_PIXEL_SUCCESS = 'FETCH_CLUB_INTEGRATION_PIXEL_SUCCESS';
export const FETCH_CLUB_INTEGRATION_PIXEL_FAILED = 'FETCH_CLUB_INTEGRATION_PIXEL_FAILED';

export const CLUB_REGISTRATION_STATUS = 'CLUB_REGISTRATION_STATUS';

export type LoginResponseError = [] | {};
export type ClubRegistrationError = [] | {} | null;

export enum ClubRegistrationStatus {
    NEW_REGISTRATION = 'NEW_REGISTRATION',
    EXISTING_USER_SUBSCRIBED = 'EXISTING_USER_SUBSCRIBED',
    EXISTING_USER_NOT_SUBSCRIBED = 'EXISTING_USER_NOT_SUBSCRIBED',
    WRONG_PASSWORD = 'WRONG_PASSWORD',
}

export interface ResendDoiConfirmationState {
    doiMessage?: String;
    doiError?: ClubRegistrationError;
    isFetching: boolean;
    didInvalidate: boolean;
}

export interface ClubRegistrationState {
    doi: ResendDoiConfirmationState;
    status?: ClubRegistrationStatus;
}

export interface IsFacebookOnlyUserState {
    isFetching: boolean;
    didInvalidate: boolean;
    isFacebookOnlyUser: boolean;
    errors?: string[];
}

export enum SessionTypes {
    unknown = 'unknown',
    partial = 'partial',
    full = 'full',
}

export interface UserData {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    registeredAt: string;
    loginHash: string;
    hashedId: string;
    hashedEmail: string;
    sessionType: SessionTypes;
}

export interface UserLoginDataResponse extends Partial<UserData> {
    isLoggedIn: boolean;
    isUserRegistered?: false | '1'; // don't ask
    errors?: ValidationErrors;
    isUserAlreadyExisting?: boolean;
}

export interface ValidationErrors {
    email?: string | string[];
    password?: string | string[];
}

export interface ClubIntegrationPixelResponse {
    success: boolean;
    data: {
        authImageUrl?: string;
    };
    errors: string[];
}

export interface ClubIntegrationPixelState {
    isFetching: boolean;
    didInvalidate: boolean;
    url: string;
    error: Error | null;
}

export interface FetchClubIntegrationPixelAction {
    type: typeof FETCH_CLUB_INTEGRATION_PIXEL;
}

export interface FetchClubIntegrationPixelSuccessAction {
    type: typeof FETCH_CLUB_INTEGRATION_PIXEL_SUCCESS;
    payload: ClubIntegrationPixelResponse;
}

export interface FetchClubIntegrationPixelFailedAction {
    type: typeof FETCH_CLUB_INTEGRATION_PIXEL_FAILED;
    payload: Error;
}

export interface LoginResponse {
    success: boolean;
    data: UserLoginDataResponse;
    error: LoginResponseError;
}

export interface LoginState {
    isFetching: boolean;
    didInvalidate: boolean;
    didFinishOnce: boolean;
    isLoggedIn: boolean;
    isRegistered: boolean;
    isRegisteredWithNewsletter: boolean;
    data: UserData | undefined;
    redirectUrl?: string;
    error: ValidationErrors | Error;
}

export interface RegisterUserValuesEmailPassword {
    email: string;
    password: string;
}
export interface RegisterUserValues extends RegisterUserValuesEmailPassword {
    isNewsletterSubscribed?: boolean | string;
    isTermsAccepted: boolean;
    isClubNewsletterSubscribed?: boolean | string;
    registrationSource?: string;
    registrationPlatform?: string;
}

export interface RegisterNewUserAction {
    type: typeof REGISTER_NEW_USER;
    payload: RegisterUserValues;
}

export interface LoginAction {
    type: typeof LOGIN;
    payload: {
        username: string;
        password: string;
    };
}

export interface LoginWithFacebookAction {
    type: typeof LOGIN_WITH_FACEBOOK;
    payload: {
        token: string;
    };
}

export interface IsLoggedInAction {
    type: typeof IS_LOGGED_IN;
}

export interface SetRedirectUrlAction {
    type: typeof SET_REDIRECT_URL;
    payload: {
        url: string;
    };
}

export interface UnSetRedirectUrlAction {
    type: typeof UNSET_REDIRECT_URL;
}

export interface LoginSuccessAction {
    type: typeof LOGIN_SUCCESS;
    payload: LoginResponse;
}

export interface LoginFailedAction {
    type: typeof LOGIN_FAILED;
    payload: LoginResponseError | Error;
}

export interface IsRegisteredAction {
    type: typeof SET_IS_REGISTERED;
    payload: { isRegistered: boolean };
}

export interface IsRegisteredWithNewsletterActions {
    type: typeof SET_IS_REGISTERED_WITH_NEWSLETTER;
}

export type LoginActionTypes =
    | RegisterNewUserAction
    | LoginAction
    | IsLoggedInAction
    | LoginSuccessAction
    | LoginFailedAction
    | SetRedirectUrlAction
    | UnSetRedirectUrlAction
    | IsRegisteredAction
    | IsRegisteredWithNewsletterActions;

export type ClubIntegrationPixelActionTypes =
    | FetchClubIntegrationPixelAction
    | FetchClubIntegrationPixelSuccessAction
    | FetchClubIntegrationPixelFailedAction;

export interface ShopToClubMessages {
    registrationSuccessMessage: string;
    alreadyRegisteredMessage: string;
}
